import React from 'react'
import { connect } from 'react-redux'
import { keys, get, sortBy } from 'lodash'
import { Link } from 'react-router-dom'
import MapChart from '../../components/MapChart'
import { makeCancelable } from '../../utils'
import Spinner from '../../components/Spinner'
import { Origin } from 'redux-tooltip'

import './index.css'

class DataExplorerTopicTFA extends React.Component {
  state = {
    indicatorData: null,
    loading: true,
  }

  componentWillMount = () => {
    const { match } = this.props
    const { topic } = match.params
    const fileName = `/tfa/data_tfa_articles.json`

    this.fetcher = makeCancelable(fetch(fileName))
    this.fetcher.promise.then(response => {
      return response.json().then(data => {
        this.setState({ indicatorData: data[topic], loading: false })
      })
    })
  }

  componentWillUnmount = () => {
    this.fetcher.cancel()
  }

  render() {
    const { countries, match } = this.props
    const { topic } = match.params
    const { indicatorData, loading } = this.state

    //const indicatorData = dataByIndicator[topic]
    const dataMap = keys(indicatorData).reduce((acc, val) => {
      acc[val] = indicatorData[val].v
      return acc
    }, {})

    const countriesForIndicator = sortBy(
      keys(indicatorData),
      i => countries[i],
    ).filter(i => countries[i])

    return (
      <div>
        <h2 className="f3 lh-copy text-blue">{`TFA Article ${topic}`}</h2>
        <div className="pa1 cf">
          {/* intro text */}
          {/* <p>
            {indicators[topic].fullDescription}
          </p> */}

          {loading && <Spinner />}
          {!loading && (
            <div>
              {/* previews */}
              <div>
                <div className="w-100 pa3">
                  <div className="DataExplorerCountry__Preview border-blue">
                    <MapChart
                      dataMap={dataMap}
                      height={400}
                      topic={topic}
                      showDownloads={true}
                      tfa={true}
                      interactive={false}
                      decreasing={false}
                      emptyFill={'#eee'}
                      minScale={0}
                      className="h-100"
                    />
                  </div>
                </div>
                <div className="w-100 pa3">
                  <div className="DataExplorerCountry__Preview border-blue">
                    {/* <DistributionChart indicator={topic} height={50} distributionData={latestDataByIndicator[topic]} style={{width:'100%'}}/> */}
                  </div>
                </div>
                <div className="w-100 pa3">
                  <div className="DataExplorerCountry__Preview border-blue">
                    {/* <MultiTrendChart indicatorData={indicators[topic]}
                    height={100} dataByIndicator={indicatorData} style={{width:'100%'}}/> */}
                  </div>
                </div>
              </div>

              {/* dropdown and download */}
              {/* <div>
              Dropdown here - Download here
            </div> */}

              {/* data table */}
              {/* data table header */}
              <div className="cf">
                {/* <div className="fl w-third">
                <h3 className="f3 lh-copy DataExplorer__table_heading">COUNTRY</h3>
              </div>
              <div className="fl w-third">
                <h3 className="f3 lh-copy DataExplorer__table_heading">TREND</h3>
              </div>
              <div className="fl w-third">
                <h3 className="f3 lh-copy DataExplorer__table_heading">SCORE</h3>
              </div> */}
                <div className="fl w-20">
                  <h3 className="f3 lh-copy DataExplorer__table_heading">
                    COUNTRY
                  </h3>
                </div>
                <div className="fl w-20">
                  <h3 className="f3 lh-copy DataExplorer__table_heading tl">
                    CATEGORY A
                  </h3>
                </div>
                <div className="fl w-20">
                  <h3 className="f3 lh-copy DataExplorer__table_heading tl">
                    CATEGORY B
                  </h3>
                </div>
                <div className="fl w-20">
                  <h3 className="f3 lh-copy DataExplorer__table_heading tl">
                    CATEGORY C
                  </h3>
                </div>
                <div className="fl w-20">
                  <h3 className="f3 lh-copy DataExplorer__table_heading tl">
                    SCORE
                  </h3>
                </div>
              </div>

              {countriesForIndicator.map(country => {
                //latest value
                if (!indicatorData[country]) {
                  return null
                }
                const value = indicatorData[country]['v']
                const valueA = get(indicatorData[country], 'A')
                const valueB = get(indicatorData[country], 'B')
                const valueC = get(indicatorData[country], 'C')
                //const m = indicatorData[country][lastYear]['m']

                return (
                  <div className="cf pv3 bb border-blue" key={country}>
                    <div className="fl w-20">
                      <div className="DataExplorer__Block">
                        <Link
                          className="no-underline underline-hover text-blue"
                          to={`//countries/${country}`}
                        >
                          {country} - {countries[country]}
                        </Link>
                      </div>
                    </div>
                    {/* <div className="fl w-third">
                  <div className="ph4 w-100">
                    <TrendChartTFAArticle
                      tfaArticle={topic}
                      showScores={true}
                      height={50}
                      countryCode={country} dataByCountry={indicatorData[country]}/>
                  </div>
                </div>
                <div className="fl w-third">
                  {value}
                </div> */}

                    <div className="fl w-20">
                      <div className="DataExplorer__Block">
                        <span className="DataExplorer__Value">
                          {valueC.toFixed(2)}
                        </span>
                      </div>
                    </div>

                    <div className="fl w-20 cf">
                      <div className="DataExplorer__Block">
                        <div className="w-100">
                          <div className="fl w-25 tl">
                            <span className="DataExplorer__Value">
                              {value.toFixed(2)}
                            </span>
                          </div>
                          <div className="fl w-75 tr">
                            <Origin
                              content={`Ratified on ${
                                indicatorData[country].date
                              }`}
                            >
                              MORE INFO
                            </Origin>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  countries: state.countries,
  tfaMeta: state.tfaMeta,
})

export default connect(mapStateToProps)(DataExplorerTopicTFA)



// WEBPACK FOOTER //
// ./src/pages/DataExplorerTopicTFA/index.js